import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/backoffice/')({
  head: () => ({
    meta: [{ title: 'Backoffice' }],
  }),
  beforeLoad: () => {
    throw redirect({ to: '/backoffice/customers' });
  },
});
